import { cmsNotificationSchema } from '@/services/cms/models/CmsNotification';
import { schemaFetch } from '@/services/fetch';

export const getNotifications = async () => await schemaFetch(cmsNotificationSchema.array(), '/api/notifications', {
        cache: 'no-store',
    });
